module.exports = __webpack_public_path__ + "img/camera2.49d53940.png";